module.exports = __webpack_public_path__ + "media/images/logo-53c533bef79343d05ccb5cfbf9ca8f39.svg";